import { render, staticRenderFns } from "./LevelupAttrPoint.vue?vue&type=template&id=b449f956&"
import script from "./LevelupAttrPoint.vue?vue&type=script&lang=js&"
export * from "./LevelupAttrPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports